import { useSelector } from 'react-redux';
import { getCurrentFenceGroupDetails, getCurrentFenceGroup } from 'state/fence/fenceSelector';
import style from './FenceCanvasFooter.module.scss';

const FenceCanvasFooter = () => {
  const { totalFenceWidth } = useSelector(getCurrentFenceGroupDetails);
  const { settings } = useSelector(getCurrentFenceGroup);

  const overMaxWidth = () => {
    return totalFenceWidth > settings.maxWidth;
  };

  const aroundMaxWidth = () => {
    return (
      totalFenceWidth !== settings.maxWidth &&
      totalFenceWidth > settings.maxWidth - 40 &&
      totalFenceWidth < settings.maxWidth + 40
    );
  };

  return (
    <div className={style.canvasFooter}>
      {totalFenceWidth > 0 && (
        <>
          <div>
            Hosszúság: <strong className={`${overMaxWidth() ? 'c-danger' : ''}`}>{totalFenceWidth} cm</strong>
            <span className="ms-xs me-xs">/</span>
            <strong className="me-auto">{settings.maxWidth} cm</strong>
          </div>

          <div>
            {overMaxWidth() && <strong className="me-xs c-danger">Túllépted az általad megadott hosszúságot!</strong>}
            {aroundMaxWidth() && <span>Korrigálhatod a hosszúságot a kapuk hosszúságának módosításával.</span>}
            {settings.maxWidth === totalFenceWidth && (
              <strong className="c-success">Megfelelő a kerítés hosszúsága, tovább léphetsz a kalkulációra.</strong>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default FenceCanvasFooter;
